
import { Link } from 'react-router-dom';

const HeroSection = () => {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background with overlay */}
      <div className="fixed inset-0 z-0">
        <div 
          className="absolute inset-0 bg-cover bg-center bg-no-repeat"
          style={{
            backgroundImage: `url('https://public.readdy.ai/ai/img_res/88421d7b20a764af521c4cde8be77b73.jpg')`
          }}
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/50 to-transparent"></div>
      </div>
      
      {/* Animated particles */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-1/4 left-1/4 w-2 h-2 bg-blue-400 rounded-full animate-pulse"></div>
        <div className="absolute top-1/3 right-1/3 w-1 h-1 bg-cyan-400 rounded-full animate-ping"></div>
        <div className="absolute bottom-1/4 left-1/3 w-1.5 h-1.5 bg-teal-400 rounded-full animate-pulse"></div>
      </div>

      <div className="relative z-10 container mx-auto px-6 text-left max-w-6xl">
        <div className="w-full">
          <div className="max-w-3xl">
            <h1 className="text-5xl md:text-7xl font-light text-white mb-6 leading-tight">
              Global Technology Partner
            </h1>
            <p className="text-xl md:text-2xl text-blue-200 mb-6 font-light">
              Bridging innovation across continents to empower your future
            </p>
            <p className="text-lg text-white/80 mb-12 leading-relaxed max-w-2xl">
              Strategically based in Hong Kong, Sentronics Solution Limited specializes in technology R&D, transfer, and OEM customization, connecting Europe and North America's advanced tech ecosystems with dynamic global markets.
            </p>
            
            <div className="flex flex-col sm:flex-row gap-6">
              <Link
                to="/services"
                className="px-8 py-4 bg-blue-600 hover:bg-blue-700 text-white rounded-lg transition-all duration-300 font-medium whitespace-nowrap cursor-pointer group"
              >
                <span className="flex items-center justify-center">
                  Explore Solutions
                  <i className="ri-arrow-right-line ml-2 group-hover:translate-x-1 transition-transform duration-300"></i>
                </span>
              </Link>
              <Link
                to="/contact"
                className="px-8 py-4 border-2 border-white/30 hover:border-white text-white hover:bg-white/10 rounded-lg transition-all duration-300 font-medium whitespace-nowrap cursor-pointer"
              >
                Get In Touch
              </Link>
            </div>
          </div>
        </div>
      </div>
      
      {/* Scroll indicator */}
      <div className="absolute bottom-8 right-8 text-white/60 animate-bounce">
        <i className="ri-arrow-down-line text-2xl"></i>
      </div>
    </section>
  );
};

export default HeroSection;
